import { Box } from '@mui/material';
import React from 'react';
import Logo from '../../Images/gtrc_logo.webp';

/**
 * Inline page loader — shows the Global Tamil Research Conference wordmark
 * within the content area. Used for Suspense fallbacks and initial page loads.
 * Non-blocking — sits inside the page layout, doesn't cover sidebar/nav.
 */
const Loader = ({ height, ...props }: { height?: string }) => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="column"
    height={height}
    justifyContent="center"
    gap={2.5}
    {...props}
  >
    <img
      src={Logo}
      alt="Global Tamil Research Conference"
      style={{
        width: 'min(280px, 70vw)',
        height: 'auto',
        animation: 'ldfade 1.8s ease-in-out infinite',
      }}
    />

    {/* Slim indeterminate progress bar — reads cleaner under a wide wordmark */}
    <Box
      sx={{
        position: 'relative',
        width: 'min(220px, 55vw)',
        height: 3,
        borderRadius: 3,
        overflow: 'hidden',
        bgcolor: '#efe6e6',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '40%',
          borderRadius: 3,
          background: 'linear-gradient(90deg, #b01e28, #d4a03a)',
          animation: 'ldslide 1.3s ease-in-out infinite',
        }}
      />
    </Box>

    <style>
      {`
        @keyframes ldfade { 0%,100%{opacity:1} 50%{opacity:0.55} }
        @keyframes ldslide { 0%{left:-40%} 100%{left:100%} }
      `}
    </style>
  </Box>
);

Loader.defaultProps = {
  height: '100vh',
};

export default Loader;
